import i18next from 'i18next';

import {__isAvailable, cookieHelper, gistApi, requestHelper, responseHelper} from '../_helpers';
import {cookieIdentifier, notificationConstants} from "../_constants";

const userSubscriptionIdentifier = cookieIdentifier.USER_SUBSCRIPTION;

/**
 * This service adds the following functionality
 */
export const subscriptionService = {
    getSubscriptions,
    subscribe
};

/**
 * This method gets the subscription for the current user (based on access_tokens)
 * @returns {Promise}
 */
function getSubscriptions() {
    const myHeader = requestHelper.authHeader();
    const link = '/api/subscriptions?status=active';

    return gistApi.get(link, {headers: myHeader})
        .then((response) => {
            return responseHelper.handleResponse(response)
        })
        .then(subscriptions => {
            saveSubscriptionInfoToCookie(subscriptions);    // update subscription cookie
            return subscriptions;
        })
        .catch((error) => {
            return Promise.reject( responseHelper.handleError(error.response) );
        })
}

/**
 * Save subscription information to cookie
 *
 * @param subscriptions list of current subscriptions
 */
function saveSubscriptionInfoToCookie(subscriptions) {
    if(__isAvailable(subscriptions) && Array.isArray(subscriptions)) {
        const subscriptionPlans = []
        for(const s of subscriptions) {
            if(__isAvailable(s.plan) && __isAvailable(s.plan.uuid)) {
                subscriptionPlans.push({
                    'uuid': s.plan.uuid,
                    'name': s.plan.name,
                    'description': s.plan.description
                })
            }
        }
        cookieHelper.saveStorageData(userSubscriptionIdentifier, subscriptionPlans)
    }
}

/**
 * Subscribes the user to plan with the given uuid
 *
 * @param plan the plan containing name and uuid
 * @return {Promise<never>}
 */
function subscribe(plan) {
    const myHeader = requestHelper.authHeader();
    const link = '/api/subscriptions';
    const t = i18next.t;

    return gistApi.post(link, {planUuid: plan.UUID},{headers: myHeader})
        .then((response) => {
            return responseHelper.handleResponse(response)
        })
        .then(subscription => {
            saveSubscriptionInfoToCookie([subscription]);   // update cookie after switch subscription
            return subscription;
        })
        .catch((error) => {
            let res = {
                "status": 500,
                "errorMsg": t("Sorry, we're having technical issues. Please try again.")
            };
            if (error && error.response) {
                res.status = error.response.status;
                switch (error.response.status) {
                    case 400:
                        res.errorMsg = t("Sorry, we're having technical issues. Please contact support.");
                        res.toastParams = {
                            "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                            "toastPersistence": true,
                        }
                        break;

                    case 402:
                        res.errorMsg = t("There’s a billing issue with your account. Try updating your payment info.");
                        res.redirectParams = {
                            "redirectTo": "/payment"
                        }
                        res.toastParams = {
                            "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                            "toastPersistence": true,
                        }
                        break;

                    case 404:
                        res.errorMsg = t("Sorry, we're having technical issues. Please contact support.");
                        res.toastParams = {
                            "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                            "toastPersistence": true,
                        }
                        break;

                    case 409:
                        res.errorMsg = t("Subscribed to ", {planName: plan.NAME});
                        res.redirectParams = {
                            "redirectTo": "/media"
                        }
                        res.toastParams = {
                            "toastType": notificationConstants.NOTIFICATION_TYPES.SUCCESS,  // success as already subscribed
                        }
                        break;

                    default:
                        res.toastParams = {
                            "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                        }
                        break;
                }
                return Promise.reject(res);
            }
        })
}